import { useQuery } from '@tanstack/react-query';
import { GetLandlordInfo, getLandlordInfo } from 'Services';
import { RQ_LANDLORD_INFO } from 'Utils';

const useGetLandlordInfo = (enabled?: boolean) => {
    return useQuery<GetLandlordInfo>([RQ_LANDLORD_INFO], getLandlordInfo, {
        enabled: enabled !== false
    });
};

export default useGetLandlordInfo;
